import { lazyAMapApiLoaderInstance } from 'vue-amap';
const Geo = {
  data() {
    return {
      defaultCity: {
        city: '定位中...',
        adCode: '0',
      },
    }
  },
  methods: {
    initGeo(callback = function () {
    }) {
      let self = this;
      lazyAMapApiLoaderInstance.load().then(() => {
        this.map = new AMap.Map('amapContainer', {
          center: [114.34387, 30.54279],
          zoom: 18,
          resizeEnable: true
        });
        this.map.plugin('AMap.Geolocation', () => {
          let geolocation = new AMap.Geolocation({
            GeoLocationFirst:true
          });
          geolocation.getCityInfo(function (status,result) {
            //console.log(status,result);
            switch (status){
              case "complete":
                self.defaultCity = {
                  city: result.city ? result.city : "请选择城市",
                  adCode: result.city ? result.adcode : 0
                };
                callback();
                break;
              case "error":
                self.defaultCity = {
                  city: "请选择城市",
                  adCode: "0"
                };
                callback();
                break;
            }
          });
        });
      });
    }
  }
};

export {
  Geo
}



// WEBPACK FOOTER //
// ./src/mixin/methods.js